import { Type } from 'class-transformer';
import { IsString, IsInt, IsOptional, Min } from 'class-validator';

const ACCOUNT_USERS_GROUPS_LIMIT = 20;

export class GetAccountUsersGroupsQueryDto {
  @IsOptional()
  @IsString()
  search?: string;

  @IsOptional()
  @IsString()
  groupId?: string;

  @IsOptional()
  @IsInt()
  @Min(0)
  @Type(() => Number)
  offset = 0;

  @IsOptional()
  @IsInt()
  @Min(1)
  @Type(() => Number)
  limit = ACCOUNT_USERS_GROUPS_LIMIT;
}
